export default {
  // Remove existing remote user with the same peerId
  remoteUserExists(peerId) {
    this.remoteUsers.filter((item, key) => {
      if (item.peerId == peerId) {
        this.remoteUsers.splice(key, 1);
      }
    })
  }
}

